<script setup>

import { computed, defineEmits, defineProps } from 'vue'
import { useStore } from 'vuex'


const store = useStore()
const emit = defineEmits(['callback'])

const props = defineProps({
  taskId: {type: String},
})

const reactionEnum = computed(() => store.getters['projects/getProjectReactionEnum'])

function makeOrUpdateReact(content) {
  store.dispatch('comments/updateReactForTask', {task_id: props.taskId, content } )
      .then(res => {
        emit('callback', res.data.data)
      })
      .catch(() => {})
      .finally(() => {})
}

</script>

<template>
  <div
      class="card d-flex gap-3 flex-row align-items-center shadow rounded-2 p-2">
    <i v-for="(reaction, index) in reactionEnum"
       @click.prevent="makeOrUpdateReact(reaction.value)"
       :key="index"
       class="fa cursor-pointer hovering-zoom fs-2"
       v-html="reaction.value"
    ></i>
  </div>
</template>

<style scoped>

.hovering-zoom:hover {
  transform: scale(1.2);
}

</style>